import { get } from 'lodash'
import { createSelector } from 'reselect'
import {
  AWARD_STATES,
  PAYMENT_STATES,
  PAYMENT_TYPES,
  DELIVERY_TYPES
} from 'constants/enums'

const getMissingPayment = award => {
  const paymentType = get(
    award,
    'participantRegistration.awardPayment.originPaymentType.value'
  )
  const paymentStatus = get(award, 'paymentState.value')

  const awardState = get(award, 'awardState.value')

  // if award is in higher state than assignment and approval (e.g. setup), then the award is approved and it is no
  // longer need to check if award is payed
  const isApproved = awardState !== AWARD_STATES.reg_assignment.id && awardState !== AWARD_STATES.reg_approval.id

  let missingPayment =
    paymentStatus === PAYMENT_STATES.notPaid.id &&
    (paymentType === PAYMENT_TYPES.online.id ||
      paymentType === PAYMENT_TYPES.payPal.id)

  missingPayment = missingPayment && !isApproved

  return missingPayment
}


const getMissingParentalConsent = award => {
    // If it's required and not confirmed, don't care about migrated
    return get(award, 'migrationDate') === null &&
    ![null, undefined, DELIVERY_TYPES.NOT_REQUIRED.value].includes(
      get(award, 'consentDeliveryType.value')
    ) &&
    get(award, 'isConsentDeliveryConfirmed') === false
}


export function enhanceAward(award) {
  const missingPayment = getMissingPayment(award)
  const missingParentalConsent = getMissingParentalConsent(award)
  const isBlocked = missingPayment || missingParentalConsent

  return {
    ...award,
    missingPayment,
    missingParentalConsent,
    isBlocked
  }
}


export function enhanceAwards(awards) {
  return awards.map(enhanceAward)
}


const enhance = awards => {
  return {
    ...awards,
    list: enhanceAwards(awards.list)
  }
}

export default createSelector(awards => awards, enhance)
